import React, { useEffect, useState } from "react";
import { Popup } from "react-map-gl";
import { pages } from "src/consts/pages";
import { lang } from "src/language/Strings";
import { useNavigate, useParams } from "react-router-dom";
import { routes } from "src/routes";
import { objectTypes } from "src/consts/objectTypes";
import { isMobile } from "src/utils/isMobile";
import { PopupImageGallery } from "./PopupImageGallery";
import { LocalStorageKeys } from "src/utils/localStorageKeys";
import { getImageFileFromItem } from "src/components/InspectionDataCard";
import { Container, SwipeableDrawer, Box, Typography, Button } from "@mui/material";

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import { useStore } from "src/components/Store";

export  function FeaturesList({ features }: { features: any[] }) {
  const nav = useNavigate();
  const { companyId } = useParams();
  const store = useStore();
  const excludedKeys = ["title", "Beskrivning","Dekor","Farg","Anlaggningsar","Renovering","SSinstruktion", "markerBorder", "createdAt", "companyId", "id", "featureType", "files", "Driftsstatus", "Skotseltyp","Planteringsar","Frihojd_m","Krondiameter_m", "Hojd_m", "Stamdiameter_cm", "Driftsansvar", "Bevarandevarde","Bevarandevarde_beskr", "GM_Namn", "GM_lank","Senastinventerat","Bildlank","CreationDate","ModificationDate","markerColor","Senast tömd","distance"];
  return (
    <List dense sx={{ width: '100%', bgcolor: 'background.paper' }}>
      {features.map((feature, index) => {
        const labelId = `checkbox-list-secondary-label-${feature?.properties?.id}`;
        return (
          <ListItem
            key={`${feature?.properties?.id}-${index}`}
            disablePadding
            sx={{
              alignItems: "flex-start"
            }}

          >
            <ListItemButton onClick={() => feature?.properties?.companyId && nav(routes.Egenkontroller.Pages.Show.url(feature?.properties.companyId, feature?.properties?.id))} sx={{
              minHeight: feature?.properties?.title ? "100px" : "auto",
              paddingBottom: "10px",
              paddingTop: "10px",
              borderBottom: "1px solid #e0e0e0",
              alignItems: "flex-start"
            }}>
              <ListItemAvatar sx={{
                minHeight: "90px",
                alignSelf: "flex-start"
              }}>
                <Avatar
                sx={{
                  width: "90px",
                  height: "90px",
                  objectFit: "cover",
                  bgcolor: "grey.200"
                }}
                  alt={`Avatar n°${feature?.properties?.id}`}
                  variant="square"
                  src={feature?.properties?.files?.[0]?.files?.[0] || feature?.properties?.files?.[0]}
                >
                  {!feature?.properties?.files?.[0]?.files?.[0] && !feature?.properties?.files?.[0] && (
                    <svg
                      width="50"
                      height="50"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="3"
                        y="3"
                        width="18"
                        height="18"
                        rx="2"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                      />
                      <circle
                        cx="8.5"
                        cy="8.5"
                        r="1.5"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                      />
                      <path
                        d="M21 15L16 10L11 15L8 12L3 17"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        fill="none"
                      />
                    </svg>
                  )}
                </Avatar>

              </ListItemAvatar>
              <Box sx={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                minWidth: 0,
                padding: 0,
                gap: 0.5
              }}>
              {feature?.properties?.title || feature.properties?.fileType === "Image" ?  <div className="ml-2">
              
              <ListItemText id={labelId} primary={`${lang.address}: `} secondary={feature?.properties?.title || feature.properties?.position?.adress} sx={{ 
                "& .MuiListItemText-primary": { 
                  wordBreak: "break-word",
                  overflowWrap: "break-word"
                },
                "& .MuiListItemText-secondary": { 
                  wordBreak: "break-word",
                  overflowWrap: "break-word"
                }
              }} />
              {feature?.properties?.fileType === "Image" && <ListItemText id={labelId} primary={`${lang.image}`} sx={{ 
                "& .MuiListItemText-primary": { 
                  wordBreak: "break-word",
                  overflowWrap: "break-word"
                }
              }} />
            }
              <ListItemText id={labelId} secondary={new Date(feature?.properties?.createdAt || feature?.properties?.position?.createdAt).toLocaleDateString()} sx={{ 
                "& .MuiListItemText-secondary": { 
                  wordBreak: "break-word",
                  overflowWrap: "break-word"
                }
              }} />
              </div> : 
              <Box sx={{
                display: "grid",
                gridTemplateColumns: "auto 1fr",
                gap: "4px 12px",
                alignItems: "baseline",
                maxHeight: "200px",
                overflowY: "auto",
                paddingRight: 1,
                "&::-webkit-scrollbar": {
                  width: "6px"
                },
                "&::-webkit-scrollbar-track": {
                  background: "transparent"
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#e0e0e0",
                  borderRadius: "3px",
                  "&:hover": {
                    background: "#bdbdbd"
                  }
                }
              }}>
              {Object.keys(feature?.properties).filter(k => !excludedKeys.includes(k)).map((key, index) => (
                <React.Fragment key={`${key}-${index}`}>
                  <Typography 
                    variant="caption" 
                    sx={{ 
                      fontWeight: 600,
                      color: "text.secondary",
                      textTransform: "none",
                      fontSize: "0.7rem",
                      letterSpacing: "0.5px",
                      whiteSpace: "nowrap"
                    }}
                  >
                    {key}:
                  </Typography>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                      color: "text.primary",
                      fontSize: "0.875rem"
                    }}
                  >
                    {String(feature?.properties[key] || "-")}
                  </Typography>
                  
                </React.Fragment>
              ))}
              
              </Box>}
             {feature?.properties?.OBJECTID && <Button
                    variant="text"
                    size="small"
                    onClick={() => {
                      store.setExternalObjectId(feature?.properties?.OBJECTID)
                      store.setDefaultInspectionComment(`${feature.properties?.Skotselkod || ""}`)
                      nav(routes.Egenkontroller.Pages.Create.url(companyId!))
                    }}
                  >
                    {lang.reportInspection}
                  </Button>}
              </Box>
            </ListItemButton>
          </ListItem>
        );
      })}
    </List>
  );
}
interface MapPopupMultipleFeaturesProps {
  features: any[];
  longitude: number;
  latitude: number;
  onClose: () => void;
}

// Unified Popup Content Component (works for both mobile and desktop)
const PopupContent: React.FC<{
  features: any[];
  onClose: () => void;
  navigate: (path: string) => void;
  companyId: string | undefined;
  isMobile?: boolean;
}> = ({ features, onClose, navigate, companyId, isMobile = false }) => {
  return (<div className="w-full h-full">
    <FeaturesList features={features} />
        {/* {features.map((feature, index) => (
          <FeatureCard
            key={`${feature.properties.featureType}-${feature.id}`}
            feature={feature}
            handleClose={onClose}
            navigate={navigate}
            companyId={companyId}
            isLast={index === features.length - 1}
          />
        ))} */}
      </div>
  );
};



// Mobile Modal Component
const MobileModal: React.FC<{
  features: any[];
  onClose: () => void;
  navigate: (path: string) => void;
  companyId: string | undefined;
}> = ({ features, onClose, navigate, companyId }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Animate in
    const timer = setTimeout(() => setIsVisible(true), 10);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 300); // Wait for animation to complete
  };

  return (
    // <div className="fixed inset-0 z-50 flex items-end">
    //   {/* Backdrop */}
    //   <div
    //     className={`absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent transition-opacity duration-300 ${
    //       isVisible ? "opacity-100" : "opacity-0"
    //     }`}
    //     onClick={handleClose}
    //     id="map-popup-backdrop"
    //   />

    //   {/* Modal */}
    //   <div
    //     className={`relative w-full transform transition-transform duration-300 ease-out ${
    //       isVisible ? "translate-y-0" : "translate-y-full"
    //     }`}
    //     style={{
    //       maxHeight: "75vh",
    //     }}
    //     id="map-popup-mobile-modal"
    //   >
    //     {/* Handle bar */}
    //     <div
    //       className="flex justify-center pt-3 pb-2"
    //       id="map-popup-mobile-handle-bar"
    //     >
    //       <div className="w-12 h-1 bg-Grey4 rounded-full" />
    //     </div>

    //     {/* Popup Content */}
    //     <div className="bg-Grey1 rounded-t-3xl shadow-2xl border-t border-Grey4">
    <SwipeableDrawer
    anchor="bottom"
    open={isVisible}
    onClose={handleClose}
    onOpen={() => {}}
    PaperProps={{
      sx: {
        height: "93vh",
        borderRadius: "16px 16px 0 0",
        padding: "26px",
      },
    }}
  >
    <div className="bg-Grey1 rounded-t-3xl shadow-2xl border-t border-Grey4 w-full text-center justify-center items-center">
      <h3 className="text-2xl font-bold text-Grey9 truncate leading-tight">{lang.objectOnLocation}</h3>
    </div>
    <FeaturesList features={features} />
          {/* <PopupContent
            features={features}
            onClose={handleClose}
            navigate={navigate}
            companyId={companyId}
            isMobile={true}
          /> */}
          </SwipeableDrawer>
    //     </div>
    //   </div>
    // </div>
  );
};

// Feature Card Component
const FeatureCard: React.FC<{
  feature: any;
  handleClose: () => void;
  navigate: (path: string) => void;
  companyId: string | undefined;
  isLast: boolean;
}> = ({ feature, handleClose, navigate, companyId, isLast }) => {
  const { deviationId, inspectionId } = useParams();
  const nav = useNavigate();
  const getStatusColor = (status: number) => {
    return status !== 1
      ? "text-PrimaryGreen bg-Grey1 border-PrimaryGreen"
      : "text-PrimaryRed bg-Grey1 border-PrimaryRed";
  };

  const getIconBg = (featureType: string) => {
    if (featureType?.includes("Image")) return "bg-AudienceYellow1";
    if (featureType?.includes("Inspection")) return "bg-PrimaryGreen";
    if (featureType?.includes("Deviation")) return "bg-PrimaryRed";
    if (featureType?.includes("MapFileFeature")) return "bg-Grey9";
    return "bg-PrimaryGreen";
  };
  if (feature.properties.featureType?.includes("MapFileFeature")){
    const propKey = feature.properties.Modell && "Modell" || feature.properties.Namn && "Namn" || feature.properties.name && "name" || feature.properties.OBJECTID && "OBJECTID" || Object.keys(feature.properties).find(k => k);
    return (
      <div key={feature.id || feature.properties.id || feature.properties.OBJECTID || Math.random().toString(36).substring(2, 15)} className="px-4 py-3 bg-White rounded-xl shadow-md border border-Grey4 mb-3 transition-all duration-200 hover:shadow-lg hover:border-Grey7">
        <h3 className="text-xl font-bold text-Grey9 truncate leading-tight">
          {feature.properties[propKey]}
        </h3>
        {Object.keys(feature.properties).filter(k => k !== propKey && !["groupId","companyId","featureType"].includes(k)).map((key) => (
          <div key={key}>
            <span className="text-xs font-semibold text-Grey7 uppercase tracking-wide">{key}:</span>
            <span className="text-xs font-medium text-Grey9">{feature.properties[key]}</span>
          </div>
        ))}
        <button title={lang.deviation} className="text-PrimaryBlack text-lg 
        hover:text-Grey9 p-2 rounded-[50px] border-2 border-Grey9 mt-2 active:scale-95 active:bg-Grey1" onClick={() => {
          localStorage.setItem(LocalStorageKeys.defaultDeviationInfo, `ObjektID: ${feature.properties.OBJECTID}, 
            Skotselkod: ${feature.properties.Skotselkod}`)
          nav(routes.Deviation.Pages.Create.url(companyId!));
        }} ><span className="text-lg">{lang.reportDeviation}</span></button>
      </div>
    );
  }
  return (
    <div
      className={`px-4 py-3 bg-White rounded-xl shadow-md  mb-3 transition-all duration-200 hover:shadow-lg hover:border-Grey7 ${
        !isLast ? "" : ""
      }`}
    >
      {/* Header */}
      <div className="flex items-start space-x-3 mb-3">
        <div
          className={` h-11 ${getIconBg(
            feature.properties.featureType
          )} rounded-xl flex items-center justify-center text-White text-lg shadow-lg px-2.5 py-1.5`}
        >
          {feature.properties.featureType === objectTypes.Inspection ? lang.inspection : feature.properties.featureType === objectTypes.Deviation ? lang.deviation : lang.image}
        </div>
        <div className="flex-1 min-w-0 h-11 flex flex-col justify-center ">
          <h3 className="text-xl font-bold text-Grey9 truncate leading-tight">
            {
              feature.title || feature.adress || feature.fileName
            }
          </h3>
          <span className="text-xl font-bold text-Grey7 capitalize">
            {feature.properties.title || feature.properties.depiction}
          </span>
        </div>
      </div>

      {feature.properties.files?.length > 0 && (
        <div className="mb-3 w-full max-w-full overflow-hidden">
          <PopupImageGallery
            id="map-popup-image-gallery"
            maxHeight="h-40"
            images={feature.properties.files?.map((file: any) => ({
              image: getImageFileFromItem(file) || file.imageResponse?.urlOriginal,
              thumbnail: file.imageResponse?.urlx240 || getImageFileFromItem(file),
              depiction: file.depiction,
              comment: file.comment,
              action: file.action,
            }))}
          />
        </div>
      )}

      <div className="space-y-2.5 mb-3 ml-[3.75rem]">
        <div className="flex items-center space-x-2">

          <span
            className={`px-2.5 py-1 rounded-lg text-xs font-medium text-Grey9 bg-Grey2 border border-Grey4`}
          >
            <span className="text-xs font-semibold text-Grey7 uppercase tracking-wide">{lang.description}:</span>{lang.description}
          </span>
        </div>
        {feature.properties.objectType === objectTypes.Inspection && (
          <div className="flex items-center space-x-2">
            <span className="text-xs font-semibold text-Grey7 uppercase tracking-wide">
              {lang.statusText}:
            </span>
            <span
              className={`px-2.5 py-1 rounded-lg text-xs font-semibold border ${getStatusColor(
                Number(feature.properties.status)
              )}`}
            >
              {Number(feature.properties.status) !== 1
                ? lang.completed
                : lang.notCompleted}
            </span>
          </div>
        )}

        {feature.properties.createdAt && (
          <div className="flex items-center space-x-2 text-xs text-Grey7 bg-Grey2 px-2.5 py-1.5 rounded-lg border border-Grey4 w-fit">
            <svg
              className="w-3.5 h-3.5 text-Grey7"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <span className="font-medium">
              {new Date(feature.properties.createdAt).toLocaleDateString()}
            </span>
          </div>
        )}
        <div>
          <a
            href={`https://www.google.com/maps/search/?api=1&query=${feature.properties.latitude},${feature.properties.longitude}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center text-xs font-medium text-PrimaryGreen hover:text-SkaneGreen bg-Grey2 hover:bg-Grey1 px-2.5 py-1.5 rounded-lg border border-PrimaryGreen transition-colors"
          >
            Google Maps{" "}
            <svg
              className="w-3.5 h-3.5 ml-1.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
              />
            </svg>
          </a>
        </div>

        {feature.properties.fileName && (
          <div className="flex items-center space-x-2 text-xs text-Grey7 bg-Grey2 px-2.5 py-1.5 rounded-lg border border-Grey4 w-fit">
            <svg
              className="w-3.5 h-3.5 text-Grey7"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
            <span className="truncate font-medium max-w-[200px]">
              {feature.properties.fileName}
            </span>
          </div>
        )}

        {feature.properties.comment && (
          <div className="text-xs text-Grey9 bg-Grey2 px-2.5 py-2 rounded-lg border border-Grey4">
            <span className="font-semibold text-Grey7">{lang.comment}:</span>{" "}
            <span className="font-medium">{feature.properties.comment}</span>
          </div>
        )}
      </div>

      {/* Action Button */}
      <button
        className="w-full bg-PrimaryGreen hover:bg-SkaneGreen text-White font-bold py-3 px-4 rounded-xl shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all duration-200 flex items-center justify-center space-x-2 text-sm"
        onClick={() => {
          handleClose();
          const featureId = Number(
            feature.properties.featureType.includes("Image")
              ? feature.properties.deviationId
              : feature.properties.id
          );
          if (!inspectionId && !deviationId) {
            if (feature.properties.featureType === objectTypes.Inspection) {
              navigate(
                routes.Egenkontroller.Pages.MapByInspectionId.url(
                  companyId,
                  featureId
                )
              );
            } else if (
              feature.properties.featureType === objectTypes.Deviation
            ) {
              navigate(
                routes.Egenkontroller.Pages.MapByDeviationId.url(
                  companyId,
                  inspectionId,
                  featureId
                )
              );
            }
          }
          if (inspectionId || deviationId) {
            switch (feature.properties.featureType) {
              case objectTypes.Inspection:
              case "Inspection-Image":
                navigate(
                  routes.Egenkontroller.Pages.Show.url(companyId, featureId)
                );
                break;
              case objectTypes.Deviation:
              case "Deviation-Image":
                navigate(routes.Deviation.Pages.Show.url(companyId, featureId));
                break;
              default:
                if (feature.properties.featureType.includes("Image")) {
                  navigate(
                    routes.Egenkontroller.Pages.Show.url(companyId, featureId)
                  );
                } else if (featureId) {
                  navigate(
                    routes.Deviation.Pages.Show.url(companyId, featureId)
                  );
                }
            }
          }
        }}
      >
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
          />
        </svg>
        <span>{lang.openInspection(feature.properties.featureType)}</span>
      </button>
    </div>
  );
};

export const MapPopupMultipleFeatures: React.FC<
  MapPopupMultipleFeaturesProps
> = ({ features, longitude, latitude, onClose }) => {
  const navigate = useNavigate();
  const { companyId } = useParams();
  // Use mobile modal for mobile devices
  if (isMobile()) {
    return (
      <MobileModal
        features={features}
        onClose={onClose}
        navigate={navigate}
        companyId={companyId}
      />
    );
  }

  // Desktop popup
  return (
    <Popup
      longitude={longitude}
      latitude={latitude}
      anchor="bottom"
      offset={[0, -15] as [number, number]}
      onClose={onClose}
      closeButton={false}
      closeOnClick={false}
      className="!border-0 !shadow-none !p-0"
    >
      <div className="rounded-2xl shadow-2xl overflow-hidden max-w-md w-full border border-Grey4 bg-Grey1">

        <PopupContent
          features={features}
          onClose={onClose}
          navigate={navigate}
          companyId={companyId}
          isMobile={false}
        />
      </div>
    </Popup>
  );
};
